export const NOT_CHOSEN = 'Not chosen yet'
export const NOT_ADDED = 'Not added yet'

export const railRows = (rows, { currentKey, visited = new Set() }) => {
  const currentIndex = Math.max(
    rows.findIndex(row => row.key === currentKey),
    0
  )
  return rows.map((row, index) => {
    const reached = visited.has(row.key) || index < currentIndex
    const state = row.key === currentKey ? 'current' : reached && row.set ? 'done' : 'upcoming'
    const earlierValid = rows.slice(0, index).every(earlier => earlier.valid)
    return {
      ...row,
      state,
      fromIncludes: false,
      addedBecause: null,
      isDefault: Boolean(row.isDefault),
      jumpable: state !== 'upcoming' || earlierValid
    }
  })
}
